// JavaScript Document

import transition from "transition-to-from-auto";

const MENUS = document.querySelectorAll(".menu-list[data-display][data-input]");

const CLOSE_ITEM = (item, menu, event, input, display) => {
    /**
     * Close all descendants
     */
    item.querySelectorAll(".menu-list__item--parent:has(.menu-list__container)").forEach((i) => {
        i.classList.remove("is-active");
    });

    /**
     * Close the item
     */
    item.classList.remove("is-active");

    /**
     * Transition accordions closed
     */
    if (display === "accordion") {
        transition({ element: item.querySelector(".menu-list__container--accordion"), val: 0 });
    }
};

const OPEN_ITEM = (item, menu, event, input, display) => {
    /**
     * Prevent navigation on initial click and touch
     */
    if (["click", "touch"].includes(input) && event !== null) {
        event.preventDefault();
    }

    /**
     * Close all items, except this one, and descendants
     */
    menu.querySelectorAll(".menu-list__item--parent:has(.menu-list__container)").forEach((i) => {
        if (i !== item && ! i.contains(item) && ! item.contains(i)) {
            CLOSE_ITEM(i, menu, null, input, display);
        }
    });

    /**
     * Open the item
     */
    item.classList.add("is-active");

    /**
     * Transition accordions open
     */
    if (display === "accordion") {
        transition({ element: item.querySelector(".menu-list__container--accordion"), val: "auto" });
    }

    /**
     * Reverse overlay if it'll be off screen
     */
    if (display === "overlay") {
        const CONTAINER = item.querySelector(".menu-list__container--overlay");

        CONTAINER.classList.remove("menu-list__container--reverse");

        const RECT   = CONTAINER.getBoundingClientRect();
        const OFFSET = RECT.left + RECT.width;

        if (OFFSET > window.innerWidth) {
            CONTAINER.classList.add("menu-list__container--reverse");
        }
    }
};

MENUS.forEach((menu) => {
    const DISPLAY = menu.dataset.display;
    const INPUT   = JSON.parse(menu.dataset.input);

    /**
     * None of this applies for "inline" menus.
     */
    if (DISPLAY === "inline") {
        return;
    }

    /**
     * Find all parent items
     */
    const ITEMS = menu.querySelectorAll(".menu-list__item--parent:has(.menu-list__container)");

    ITEMS.forEach((item) => {
        /**
         * Handle toggle
         */
        if (INPUT.includes("toggle")) {
            item.querySelector(".menu-list__toggle").addEventListener("click", (e) => {
                if (item.classList.contains("is-active")) {
                    CLOSE_ITEM(item, menu, e, "toggle", DISPLAY);
                } else {
                    OPEN_ITEM(item, menu, e, "toggle", DISPLAY);
                }
            }, { passive: false });
        }

        /**
         * Handle click
         */
        if (INPUT.includes("click")) {
            item.querySelector(".menu-list__link").addEventListener("click", (e) => {
                if (! item.classList.contains("is-active")) {
                    OPEN_ITEM(item, menu, e, "click", DISPLAY);
                }
            }, { passive: false });
        }

        /**
         * Handle touch
         */
        if (INPUT.includes("touch")) {
            item.querySelector(".menu-list__link").addEventListener("touchstart", (e) => {
                if (! item.classList.contains("is-active")) {
                    OPEN_ITEM(item, menu, e, "click", DISPLAY);
                }
            }, { passive: false });
        }

        /**
         * Handle focus
         */
        if (INPUT.includes("focus")) {
            item.addEventListener("focusin", (e) => {
                OPEN_ITEM(item, menu, e, DISPLAY, INPUT);
            }, { passive: true });

            item.addEventListener("focusout", (e) => {
                CLOSE_ITEM(item, menu, e, DISPLAY, INPUT);
            }, { passive: true });
        }

        /**
         * Handle hover
         */
        if (INPUT.includes("hover")) {
            item.addEventListener("mouseover", (e) => {
                OPEN_ITEM(item, menu, "hover", e, DISPLAY);
            }, { passive: true });

            item.addEventListener("mouseleave", (e) => {
                CLOSE_ITEM(item, menu, "hover", e, DISPLAY);
            }, { passive: true });
        }
    });

    /**
     * Close the menu when it loses focus
     */
    document.addEventListener("click", (e) => {
        if (! menu.contains(e.target) && menu.querySelector(".is-active")) {
            [...ITEMS].reverse().forEach((item) => {
                if (item.classList.contains("is-active")) {
                    CLOSE_ITEM(item, menu, null, INPUT, DISPLAY);
                }
            });
        }
    }, { passive: true });

    /**
     * Handle the overflow menu
     */
    if (menu.dataset.overflow === "true") {
        let resizing = false;

        const RESIZE_OBSERVER = new ResizeObserver(entries => {
            /**
             * If currently resizing, return
             */
            if (resizing) {
                return;
            }

            /**
             * If the toggle isn't present, return
             */
            if (menu.nextElementSibling && ! menu.nextElementSibling.classList.contains("menu-list__weblinx-panel-toggle")) {
                return;
            }

            resizing = true;

            for (const ENTRY of entries) {
                let items_width = 0;

                /**
                 * Get the items and their clones
                 */
                const ITEMS  = Array.from(menu.querySelectorAll(".menu-list[data-overflow='true'] > .menu-list__item"));
                const CLONES = Array.from(menu.parentElement.querySelectorAll(".menu-list__weblinx-panel--overflow > .weblinx-panel__inner > .menu-list > .menu-list__item"));

                /**
                 * Reset
                 */
                ITEMS.forEach(item => item.style.display = "");

                /**
                 * Hide the items that are overflowing
                 */
                for (let i = 0; i < ITEMS.length; i++) {
                    items_width += ITEMS[i].offsetWidth;

                    /**
                     * If overflowing, hide the item and show the clone
                     */
                    if (items_width > ENTRY.contentRect.width) {
                        ITEMS[i].style.display = "none";
                        CLONES[i].style.display = "";
                    } else {
                        CLONES[i].style.display = "none";
                    }

                    /**
                     * Adjust the display state of the toggle button
                     */
                    if (i === CLONES.length - 1) {
                        /**
                         * Sync the toggle button's display state
                         */
                        menu.nextElementSibling.style.display = CLONES[i].style.display;

                        /**
                         * Close the panel if all items are hidden
                         */
                        if (CLONES[i].style.display === "none" && menu.nextElementSibling.classList.contains("is-active")) {
                            menu.nextElementSibling.click();
                        }

                        /**
                         * Initialize the toggle button
                         */
                        if (! menu.nextElementSibling.classList.contains("is-initialized")) {
                            menu.nextElementSibling.classList.add("is-initialized");
                        }
                    }
                }
            }

            resizing = false;
        });

        if (menu) {
            RESIZE_OBSERVER.observe(menu);
        }
    }
});
